import React from 'react';
import Typography from '@material-ui/core/Typography';

export const buildSelectItems = optionalColumns =>
	optionalColumns.map(optColumn => ({
		value: optColumn.key,
		label: <Typography>{optColumn.label}</Typography>
	}));
